import { useParams } from 'react-router-dom';
import { PathwayCancelModal } from '../components/PathwayCancelModal';
import { usePathwayQuery } from '../documents/pathway.generated';
import {
    createModalPath,
    createModalRouteToolkit,
    useNavigateBackFromModalRoute,
} from 'src/shared/navigation/ModalRouteToolkit';
import { Modal } from '@modernhealth/vital-components';
import { CenteredSpinner } from 'src/shared/components/CenteredSpinner';

const modalPath = createModalPath('pathways/:uuid/cancel');

export const PathwayCancelModalPageComponent = () => {
    const { uuid } = useParams<{ uuid: string }>();
    const { closeModal } = useNavigateBackFromModalRoute(modalPath);
    const { data, loading } = usePathwayQuery({
        variables: {
            uuid,
        },
    });

    if (!loading && !data?.pathway) {
        return (
            <Modal isVisible maxWidth={450} onCloseButtonClick={closeModal}>
                <div css={{ minHeight: 250 }}>
                    <CenteredSpinner />
                </div>
            </Modal>
        );
    }

    const pathway = data?.pathway;

    if (!pathway?.memberPathway?.pathwayProvider) {
        return null;
    }

    return (
        <PathwayCancelModal
            pathway={pathway.title}
            pathwayUuid={pathway.uuid}
            provider={pathway.memberPathway.pathwayProvider.provider}
            onClose={closeModal}
        />
    );
};

export const PathwayCancelModalPage = createModalRouteToolkit({
    modalPath,
    component: PathwayCancelModalPageComponent,
});
